import PropTypes from 'prop-types';
import TextStyle from './styled';
TextStyle.defaultProps = {
  children: null,
  color: null,
  bold: false,
  center: false
};
TextStyle.propTypes = {
  children: PropTypes.node,
  color: PropTypes.string,
  bold: PropTypes.bool,
  center: PropTypes.bool
};
export default TextStyle;